import { useMemo } from 'react';
import Image from 'next/legacy/image';
import styled, { DefaultTheme } from 'styled-components';
import { Col } from 'antd';

import useI18n from '../../common/hooks/useI18n';

type Props = {
  property: string;
  query: string;
  theme: DefaultTheme;
};

const CenteredDiv = styled.div`
  text-align: center;
`;

const ImageFlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;

  @media ${(props) => props.theme.breakpoints.smd} {
    height: 80px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  height: 100%;
  width: 120px;

  img {
    border-radius: 50%;
  }

  @media ${(props) => props.theme.breakpoints.smd} {
    width: 80px;
  }
`;

const Title = styled.div`
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
  margin-top: 24px;
`;

const Description = styled.div`
  font-size: 18px;
  line-height: 32px;
  margin-top: 16px;

  @media ${(props) => props.theme.breakpoints.lgd} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.breakpoints.smd} {
    line-height: 22px;
  }
`;

const WhySellWithUsProperty: React.FC<Props> = ({ property, query, theme }) => {
  const i18n = useI18n();

  const description = useMemo(
    () => i18n.t(`dynamic.sellHousePage.${query}.${property}Description`),
    [i18n, query, property]
  );

  return (
    <Col xs={24} md={8}>
      <CenteredDiv>
        <ImageFlexContainer>
          <ImageContainer>
            <Image
              alt={i18n.t(`dynamic.sellHousePage.${query}.${property}Title`)}
              layout="fill"
              objectFit="cover"
              src={`/images/sell_house/why_sell_with_us/${property}.svg`}
              sizes={theme.getImageSizes(
                '100vw',
                '100vw',
                '50vw',
                '50vw',
                '25vh'
              )}
            />
          </ImageContainer>
        </ImageFlexContainer>
        <Title>
          {i18n.t(`dynamic.sellHousePage.${query}.${property}Title`)}
        </Title>
        <Description
          key={description.substring(0, 10) + new Date().getTime()}
          as="div"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </CenteredDiv>
    </Col>
  );
};

export default WhySellWithUsProperty;
